import React from 'react'

import * as style from './style.module.sass'

type ArtisanTopHeadlineProps = {
  heading: string
  isRight?: boolean
}

const ArtisanTopHeadline: React.FC<ArtisanTopHeadlineProps> = ({
  heading,
  isRight = false,
}) => {
  return (
    <div className={style.container} data-right={isRight}>
      <h2 className={style.heading}>{heading}</h2>
    </div>
  )
}

export default ArtisanTopHeadline
